import Decimal from 'decimal.js';
import { fromDatestampObject, toDatestampObject } from "./time";
export let PriceIncreaseType = /*#__PURE__*/function (PriceIncreaseType) {
  PriceIncreaseType["None"] = "none";
  PriceIncreaseType["Automatic"] = "automatic";
  return PriceIncreaseType;
}({});
export let IncreaseMethodType = /*#__PURE__*/function (IncreaseMethodType) {
  IncreaseMethodType["Percent"] = "percent";
  return IncreaseMethodType;
}({});
export let RoundPrices = /*#__PURE__*/function (RoundPrices) {
  RoundPrices["None"] = "none";
  RoundPrices["Down1"] = "down1";
  RoundPrices["Down5"] = "down5";
  RoundPrices["Down10"] = "down10";
  return RoundPrices;
}({});
export let IncreaseOnType = /*#__PURE__*/function (IncreaseOnType) {
  IncreaseOnType["Yearly"] = "yearly";
  IncreaseOnType["EffectiveDate"] = "yearlyEffectiveDate";
  return IncreaseOnType;
}({});
export class PriceIncreaseModel {
  static fromDTO(dto) {
    switch (dto.type) {
      case PriceIncreaseType.None:
        return PriceIncreaseModel.makeNone();
      case PriceIncreaseType.Automatic:
        return PriceIncreaseModel.make(dto.automatic.roundPrices, new Decimal(dto.automatic.increaseMethod.percent), dto.automatic.increaseOn.periodType === IncreaseOnType.Yearly ? fromDatestampObject(dto.automatic.increaseOn.yearly) : null);
    }
  }
  static make(roundPrices, percentIncrease, increaseOn) {
    return new PriceIncreaseModel({
      roundPrices,
      percentIncrease,
      increaseOn
    });
  }
  static makeNone() {
    return new PriceIncreaseModel(null);
  }
  constructor(data) {
    this.data = data;
  }
  toDTO() {
    if (!this.data) {
      return {
        type: PriceIncreaseType.None
      };
    }
    return {
      type: PriceIncreaseType.Automatic,
      automatic: {
        roundPrices: this.data.roundPrices,
        increaseMethod: {
          type: IncreaseMethodType.Percent,
          percent: this.data.percentIncrease.toString()
        },
        increaseOn: this.data.increaseOn ? {
          periodType: IncreaseOnType.Yearly,
          yearly: toDatestampObject(this.data.increaseOn)
        } : {
          periodType: IncreaseOnType.EffectiveDate
        }
      }
    };
  }
  toDB() {
    if (!this.data) {
      return {
        type: PriceIncreaseType.None
      };
    }
    return {
      type: PriceIncreaseType.Automatic,
      automatic: {
        roundPrices: this.data.roundPrices,
        increaseMethod: {
          type: IncreaseMethodType.Percent,
          percent: this.data.percentIncrease.mul(100).toDP(0).toNumber()
        },
        increaseOn: this.data.increaseOn ? {
          periodType: IncreaseOnType.Yearly,
          yearly: toDatestampObject(this.data.increaseOn)
        } : {
          periodType: IncreaseOnType.EffectiveDate
        }
      }
    };
  }
  exists() {
    return !!this.data;
  }
  isNonPositiveIncrease() {
    return !this.data || this.data.percentIncrease.isZero() || this.data.percentIncrease.isNegative();
  }
  percentIncrease() {
    return this.data ? this.data.percentIncrease : new Decimal(0);
  }
  roundPrices() {
    return this.data ? this.data.roundPrices : RoundPrices.None;
  }
  increaseOn() {
    return this.data ? this.data.increaseOn : null;
  }
}